import { Box, Grid, Typography, styled } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { theme } from "../Theme";
import UnderlineT from "../components/UnderlineT";
import GreatLakesLogo from "../img/GreatLakesLogo.png";
import tooth1 from "../img/tooth1.png";
import tooth2 from "../img/tooth2.png";
import tooth3 from "../img/tooth3.png";
import tooth4 from "../img/tooth4.png";
import tooth5 from "../img/tooth5.png";
import tooth6 from "../img/tooth6.png";
import tooth7 from "../img/tooth7.png";
import tooth8 from "../img/tooth8.png";
import tooth9 from "../img/tooth9.png";
import BoneGrafting from "./BoneGrafting";
import CorrectiveJaw from "./CorrectiveJaw";
import DentalImplants from "./DentalImplants";
import Extraction from "./Extraction";
import FacialTrauma from "./FacialTrauma";
import OralPathology from "./OralPathology";
import OrthodonticSurgery from "./OrthodonticSurgery";
import TMJDisorder from "./TMJDisorder";
import WisdomTeeth from "./WisdomTeeth";

const SurgeryDrop = styled(NavLink)(({ theme }) => ({
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  minHeight: "40px",
  textDecoration: "none",
  width: "100%",
  maxWidth: "250px",
  margin: "10px",
  color: theme.palette.text.primary,

  "&:hover": {
    backgroundColor: theme.palette.teal.main,
    cursor: "pointer",
    color: theme.palette.text.white,
  },
  "&:hover img": {
    filter: "brightness(0) invert(1)",
  },
}));

let activeDrop = {
  backgroundColor: theme.palette.teal.main,
  color: theme.palette.text.white,
};

let activeImg = {
  filter: "brightness(0) invert(1)",
};

const SurgeryImg = styled("img")(({ theme }) => ({
  margin: "5px 10px",
  width: "50px",
}));

function SurgeryItem(props) {
  return (
    <SurgeryDrop
      to={`${props.text.toLowerCase().replaceAll(" ", "-")}`}
      style={({ isActive }) => (isActive ? activeDrop : null)}
    >
      {({ isActive }) => (
        <>
          <SurgeryImg
            style={isActive ? activeImg : null}
            src={props.image}
            alt={props.text}
          />
          <Typography variant="h6">{props.text}</Typography>
        </>
      )}
    </SurgeryDrop>
  );
}

function Surgery() {
  return (
    <>
      <Helmet>
        <title>
          Our Procedures - Great Lakes Oral & Maxillofacial Surgery Centre
        </title>
        <meta
          name="description"
          content="Great Lakes Oral & Maxillofacial Surgery Centre offers a suite of state-of-the-art procedures, ranging from routine tooth extraction to traumatic facial and jaw surgeries."
        />
        {/* End standard metadata tags */}
        {/* Facebook tags */}
        <meta property="og:type" content="website" />
        <meta property="og:image" content={GreatLakesLogo} />
        <meta
          property="og:title"
          content="Our Procedures - Great Lakes Oral & Maxillofacial Surgery Centre"
        />
        <meta
          property="og:url"
          content="http://www.greatlakessurgerycentre.com/surgery"
        />
        <meta
          property="og:description"
          content="Great Lakes Oral & Maxillofacial Surgery Centre offers a suite of state-of-the-art procedures, ranging from routine tooth extraction to traumatic facial and jaw surgeries."
        />
        {/* End Facebook tags */}
        {/* Twitter tags */}

        {/* End Twitter tags */}
      </Helmet>
      <Box sx={{ minHeight: "100vh", padding: "150px 0px" }}>
        <Grid container>
          <Grid item container flexDirection="column" alignItems="center">
            <Typography
              variant="h4"
              sx={{ marginBottom: { xs: "30px", sm: "70px" } }}
            >
              Our Procedures
              <UnderlineT />
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={4}
            flexDirection="column"
            alignItems={{ xs: "center", md: "flex-end" }}
            sx={{
              padding: "20px",
              paddingTop: "0px",
              borderRight: { xs: "none", sm: "2px solid grey" },
            }}
          >
            {/* <SurgeryItem text="Before Surgery" image={tooth10} /> */}
            <SurgeryItem text="Dental Implants" image={tooth1} />
            <SurgeryItem text="Wisdom Teeth" image={tooth2} />
            <SurgeryItem text="Tooth Extraction" image={tooth3} />
            <SurgeryItem text="Bone Grafting" image={tooth4} />
            <SurgeryItem text="Orthodontic Surgery" image={tooth5} />
            <SurgeryItem text="Facial Trauma" image={tooth6} />
            <SurgeryItem text="Oral Pathology" image={tooth7} />
            <SurgeryItem text="Jaw Corrective" image={tooth8} />
            <SurgeryItem text="TMJ Disorder" image={tooth9} />
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={8}
            flexDirection="column"
            sx={{ padding: "30px", paddingTop: "0px" }}
          >
            <Routes>
              {/* <Route path="before-surgery" element={<BeforeSurgery />} /> */}
              <Route path="dental-implants" element={<DentalImplants />} />
              <Route
                index
                path="/"
                element={<Navigate to="dental-implants" />}
              />

              <Route path="wisdom-teeth" element={<WisdomTeeth />} />
              <Route path="tooth-extraction" element={<Extraction />} />
              <Route path="bone-grafting" element={<BoneGrafting />} />
              <Route
                path="orthodontic-surgery"
                element={<OrthodonticSurgery />}
              />
              <Route path="facial-trauma" element={<FacialTrauma />} />
              <Route path="oral-pathology" element={<OralPathology />} />
              <Route path="jaw-corrective" element={<CorrectiveJaw />} />
              <Route path="tmj-disorder" element={<TMJDisorder />} />
            </Routes>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Surgery;
